module.exports = __webpack_public_path__ + "static/media/Uploading-bro.0279c447.png";